import React from 'react'
import styled from 'styled-components'
import Rows from '../'

const Container = styled.div`
  padding-left: 47px;
`

export default ({ items, ...rest }) => (
  <Container>
    <Rows isItem {...rest} withCustom />
  </Container>
)
